// Renders owner-written text with the little bit of markdown people paste in:
// **bold** and [label](https://link). Built as React elements (never raw
// HTML), so nothing in a description can inject markup. Links must be
// http(s); anything else shows as its plain label. Line breaks are kept.
const TOKEN = /(\*\*[^*\n]+\*\*|\[[^\]\n]+\]\([^)\s]+\))/g
const LINK = /^\[([^\]]+)\]\(([^)\s]+)\)$/

export default function FormattedText({ text, style }) {
if (!text) return null
const parts = String(text).split(TOKEN)
return (
<p style={{ whiteSpace: 'pre-line', ...style }}>
{parts.map((part, i) => {
if (part.startsWith('**') && part.endsWith('**') && part.length > 4) {
return <strong key={i}>{part.slice(2, -2)}</strong>
}
const link = part.match(LINK)
if (link) {
const [, label, url] = link
if (!/^https?:\/\//i.test(url)) return label
return <a key={i} href={url} target="_blank" rel="noopener noreferrer nofollow ugc" style={{ color: 'var(--primary)', textDecoration: 'underline' }}>{label}</a>
}
return part
})}
</p>
)
}
